import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const CreditServices = {
  getList: async () => {
    const response = await apiService.get(`${slug}/bill-payment-credit/getall`);
    return response.data;
  },
};

export default CreditServices;
